export const tinymceInitConfig = {
    height: 500,
    menubar: true,
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
    ],
    toolbar:
        'fullscreen | media | undo redo | formatselect | bold italic backcolor | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help',
    verify_html: false,
    valid_elements: '*[*]',
    valid_children: '+body[style|script]',
    extended_valid_elements: 'script[*],style[*]',
}

export const tinymceApiKey = process.env.MIX_TINYMCE_API_KEY
